import { makeStyles, type Theme } from "@material-ui/core";

export const useStyles = makeStyles((theme: Theme) => ({
  introDetails: {
    margin: "20px 0px 30px 0px",
    "& img": {
      width: "95%",
      maxHeight: "100%",
    },
  },
  intro: {
    color: "#0F172A",
    fontFamily: "Inter",
    fontWeight: 600,
    fontSize: theme.typography.pxToRem(23),
  },
  body: {
    color: "#000000",
    fontFamily: "Lato",
    fontWeight: 400,
    fontSize: theme.typography.pxToRem(22),
  },
  alignCenter: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  popper: {
    zIndex: 1,
    '&[x-placement*="bottom"] $arrow': {
      top: 0,
      left: 0,
      marginTop: "-0.9em",
      width: "3em",
      height: "1em",
      "&::before": {
        borderWidth: "0 1em 1em 1em",
        borderColor: `transparent transparent ${theme.palette.background.paper} transparent`,
      },
    },
    '&[x-placement*="top"] $arrow': {
      bottom: 0,
      left: 0,
      marginBottom: "-0.9em",
      width: "3em",
      height: "1em",
      "&::before": {
        borderWidth: "1em 1em 0 1em",
        borderColor: `${theme.palette.background.paper} transparent transparent transparent`,
      },
    },
    '&[x-placement*="right"] $arrow': {
      left: 0,
      marginLeft: "-0.9em",
      height: "3em",
      width: "1em",
      "&::before": {
        borderWidth: "1em 1em 1em 0",
        borderColor: `transparent ${theme.palette.background.paper} transparent transparent`,
      },
    },
    '&[x-placement*="left"] $arrow': {
      right: 0,
      marginTop: "25px",
      marginRight: "-0.9em",
      height: "3em",
      width: "1em",
      "&::before": {
        borderWidth: "1em 0 1em 1em",
        borderColor: `transparent transparent transparent ${theme.palette.background.paper}`,
      },
    },
  },
  arrow: {
    position: "absolute",
    fontSize: 7,
    width: "3em",
    height: "3em",
    "&::before": {
      content: '""',
      margin: "auto",
      display: "block",
      width: 0,
      height: 0,
      borderStyle: "solid",
    },
  },
  slideIndicatorContainer: {
    width: "30px",
    margin: "auto",
  },
  slideIndicator: {
    height: "60px",
    width: "5px",
    background: "#D3F7F1",
    borderRadius: "100px",
    border: "0px  #D3F7F1",
    outline: "0px",
    boxShadow: "none",
  },
  slideActiveIndicator: {
    backgroundColor: "#22D9BB",
    outline: "0px",
  },
}));
